<template>
    <div class="main_unit">
        <div class="top_unit">
            <div class="top_name_box">{{getStaffName}}</div>
            <div class="top_center_box"> </div>
        </div>

        <div class="chori_check_menu2">
            <ul>
                <li v-for="(menuData, index) in importantCheckButtonList" :key="menuData.importantButtonId" v-show="menuData.displayFlg" >
                    <div :class="classList['a'][index]">
                        {{menuData.upperButtonName}}
                    </div>
                    <div class="chori_check_tex2">
                        <CookingMenuButton :menuId="menuId" :subMenuId="menuData.importantButtonId" :lowerButtonName="menuData.lowerButtonName"
                                           :upperButtonName="menuData.upperButtonName"/>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import CookingMenuButton from '@/app/components/CookingMenuButton.vue'

    export default {
        name: 'CookingCheckMenu',
        components: {
            CookingMenuButton
        },
        computed:{
            getStaffName:function () {
                return  this.$store.getters['staff/name'];
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        data: function () {
            return {
                menuId:0,
                classList: {
                    a: [
                        'chori_check_index chori_bg01',
                        'chori_check_index chori_bg02',
                        'chori_check_index chori_bg03',
                        'chori_check_index chori_bg04',
                        'chori_check_index chori_bg05',
                    ]
                },
                importantCheckButtonList: [
                    {
                        "importantButtonId": 0,
                        "upperButtonName": "",
                        "lowerButtonName": "",
                        "displayFlg": null
                    }
                ],
            }
        },
        mounted () {

            this.menuId = Number(this.$route.params.menuId);
            var brandId = this.$store.getters['brand/id'];
            var topButtonId = this.menuId;
            var datetime = this.dateFormat();
            var url = this.$apiEndpoint + 'user/brand/' + brandId + '/top/' + topButtonId + '/cooking_menu?date=' + datetime;

            this.$axios
                .get(url)
                .then(response => {
                    this.importantCheckButtonList = response.data.importantCheckButtonList
                    this.$store.dispatch('buttons/set', { key: 'cookingCheckMenu', list: this.importantCheckButtonList })
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                });
        },
        methods:{
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            }
        }
    }
</script>
